/* owkar-article.js - OWKAR Single Blog Post Specific Interactions */

function initArticleScripts() {
  initBannerParallax();
  enhanceBlogTables();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleScripts);
} else {
  initArticleScripts();
}

document.addEventListener('shopify:section:load', () => {
  enhanceBlogTables();
});

/* --- Blog Article Tables Enhancement & Sanitization --- */
function enhanceBlogTables() {
  const tables = document.querySelectorAll('.article-rich-text table, .article-content-wrapper table, .blog-post-content table, .rte table, .blog-table, table.blog-table');
  if (!tables || tables.length === 0) return;

  tables.forEach((table) => {
    // 1. Remove unwanted inline styles often injected by copy-pasting from Word/Google Docs/Shopify RTE
    table.removeAttribute('style');
    
    // Check all child elements inside the table
    const allDescendants = table.querySelectorAll('thead, tbody, tr, th, td, p, span, strong, em, div');
    allDescendants.forEach((el) => {
      if (el.hasAttribute('style')) {
        // Clear background colors and text colors that conflict with dark mode
        el.style.backgroundColor = '';
        el.style.background = '';
        el.style.color = '';
        el.style.borderColor = '';
        el.style.border = '';
        el.style.fontFamily = '';
      }
    });

    // 2. Remove completely empty rows or headers (e.g. phantom white bar rows from copy-paste)
    const rows = table.querySelectorAll('tr');
    rows.forEach((row) => {
      const text = row.textContent.trim();
      const hasMeaningfulContent = text.length > 0 || row.querySelector('img, svg, input');
      if (!hasMeaningfulContent && row.children.length > 0) {
        // Check if all cells in row are empty
        let allCellsEmpty = true;
        Array.from(row.children).forEach(cell => {
          if (cell.textContent.trim().length > 0 || cell.querySelector('img, svg')) {
            allCellsEmpty = false;
          }
        });
        if (allCellsEmpty) {
          row.remove();
        }
      }
    });

    // 3. Ensure tables are wrapped in a responsive scroll container
    if (!table.parentElement || !table.parentElement.classList.contains('article-table-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'article-table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    // 4. If table has no <th> tag, treat first row as header
    if (!table.querySelector('th')) {
      const firstRow = table.querySelector('tr');
      if (firstRow) {
        firstRow.classList.add('table-inferred-header');
      }
    }
  });
}

/* --- Banner Parallax Effect --- */
function initBannerParallax() {
  const banner = document.querySelector('.space-banner-card');
  const bannerImg = document.querySelector('.space-banner-img');
  if (!banner || !bannerImg) return;

  function handleParallax() {
    const rect = banner.getBoundingClientRect();
    const viewHeight = window.innerHeight;
    if (rect.top < viewHeight && rect.bottom > 0) {
      const scrollProgress = (viewHeight - rect.top) / (viewHeight + rect.height);
      const translateY = (scrollProgress - 0.5) * 80;
      bannerImg.style.transform = `translateY(${translateY}px)`;
    }
  }

  window.addEventListener('scroll', handleParallax);
  window.addEventListener('resize', handleParallax);
  handleParallax();
}
